// Groups digits by locale (Persian digits in the Persian UI). "-" when there is no price.
export const formatPrice = (price: number | null | undefined, lang: string): string =>
    price === null || price === undefined
        ? "-"
        : new Intl.NumberFormat(lang === "fa" ? "fa-IR" : "en-US").format(price);